import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const rootStylesMap = {
  horizontal: 'w-full',
  vertical: 'flex-col items-stretch'
};
const borderDirectionMap = {
  horizontal: 'border-b',
  vertical: 'border-r'
};
const borderStyleMap = {
  solid: 'border-solid',
  dashed: 'border-dashed'
};
function Divider({
  children,
  className,
  borderStyle = 'solid',
  direction = 'horizontal',
  borderColor = 'border-gray'
}) {
  return jsxs("div", {
    className: clsx('flex items-center', rootStylesMap[direction], className),
    children: [jsx("div", {
      className: clsx('flex-1 border-0', borderColor, borderStyleMap[borderStyle], borderDirectionMap[direction])
    }), children, jsx("div", {
      className: clsx('flex-1 border-0', borderColor, borderStyleMap[borderStyle], borderDirectionMap[direction])
    })]
  });
}

export { Divider };
